// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "table#table-handling .flip-list-move[data-v-38fa3730] {\n  transition: -webkit-transform 1s;\n  transition: transform 1s;\n  transition: transform 1s, -webkit-transform 1s;\n}[dir] table#table-handling .flip-list-move[data-v-38fa3730] {\n  -webkit-transition: -webkit-transform 1s;\n}", ""]);
// Exports
module.exports = exports;
